// extracted by mini-css-extract-plugin
module.exports = {"icon":"icons_icon__2BAYa"};